// extracted by mini-css-extract-plugin
export default {"video-section":"n_br d-flex","video-section--header":"n_bs","video-section__frame":"n_bt ml-3"};